import { render, staticRenderFns } from "./RegisterWithToken.vue?vue&type=template&id=02916190&"
import script from "./RegisterWithToken.vue?vue&type=script&lang=js&"
export * from "./RegisterWithToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02916190')) {
      api.createRecord('02916190', component.options)
    } else {
      api.reload('02916190', component.options)
    }
    module.hot.accept("./RegisterWithToken.vue?vue&type=template&id=02916190&", function () {
      api.rerender('02916190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/RegisterWithToken.vue"
export default component.exports